// app/javascript/controllers/ajax_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["errors"]
  static values = {
    successPanelId: String,
    currentPanelId: String
  }

  async submit(event) {
    event.preventDefault()

    // reset erreurs visuelles
    if (this.hasErrorsTarget) this.errorsTarget.innerHTML = ""

    const form = event.currentTarget
    const url  = form.action
    const data = new FormData(form)

    // Envoie en JSON; on demande du JSON côté serveur
    const response = await fetch(url, {
      method: "POST",
      headers: { "Accept": "application/json" },
      body: data,
      credentials: "same-origin"
    })

    if (response.ok) {
      // 200/201/204 => succès : on ouvre le 3e panel et ferme le 2e via ton event global
      window.dispatchEvent(new CustomEvent("more-panel:open", {
        detail: { id: this.successPanelIdValue || "contact-success" }
      }))
      // Optionnel: reset du formulaire
      form.reset()
    } else if (response.status === 422) {
      // erreurs de validation => on affiche
      let payload
      try {
        payload = await response.json()
      } catch {
        payload = { errors: { base: ["Une erreur est survenue."] } }
      }
      this.renderErrors(payload.errors)
    } else if (response.status === 400 || response.status === 403) {
      // reCAPTCHA / droits
      let payload
      try { payload = await response.json() } catch { payload = {} }
      this.renderErrors(payload.errors || { base: ["Vérification échouée."] })
    } else {
      this.renderErrors({ base: [`Erreur serveur (${response.status})`] })
    }
  }

  renderErrors(errors) {
    if (!this.hasErrorsTarget) return

    // errors attendu au format { field: ["msg1","msg2"], base: ["msg"] }
    const items = []
    for (const [field, msgs] of Object.entries(errors || {})) {
      (msgs || []).forEach(m => items.push(`<li>${field === "base" ? "" : `<strong>${field}</strong> `}${m}</li>`))
    }
    if (items.length > 0) {
      this.errorsTarget.innerHTML = `<ul class="list-disc pl-5">${items.join("")}</ul>`
    }
  }
}
